// extracted by mini-css-extract-plugin
export var cardHeader = "_hc-1";
export var contentCard = "_hc-0";
export var headerActions = "_hc-3";
export var reorderHandle = "_hc-5";
export var titleArea = "_hc-2";
export var titleAreaWithHandle = "_hc-4";